export const changedFieldInputSx = {
  '& .MuiInput-underline:before': { borderBottomColor: 'warning.main' },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'warning.dark' },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: 'warning.main' },
  },
} as const;
